// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3y30w","info":"Note_info__1v0MD","note":"Note_note__MY-kd","actions":"Note_actions__1ewZP"};